import { Link, createFileRoute } from "@tanstack/react-router";
import { Button } from "@patient-watch/ui/button";
import { Download, Plus } from "lucide-react";
import { toast } from "@patient-watch/ui/sonner";
import { ArtifactsTable } from "@/features/lead-gen/components/ArtifactsTable";
import { LeadGenNavTabs } from "@/features/lead-gen/components/LeadGenNavTabs";
import { useLeadGen } from "@/features/lead-gen/LeadGenContext";
import { useNav } from "@/utils/nav";

export const Route = createFileRoute("/_app/sales/leads/artifacts/")({
    component: LeadArtifactsPage,
});

function LeadArtifactsPage() {
    const { artifacts, templates, removeArtifact, exportSql } = useLeadGen();

    useNav([
        { label: "Sales", route: { to: "/sales/leads" } },
        { label: "Leads", route: { to: "/sales/leads" } },
        { label: "Artefacts", route: { to: "/sales/leads/artifacts" } },
    ]);

    return (
        <>
            <LeadGenNavTabs
                action={
                    <div className="flex items-center gap-2">
                        <Button
                            type="button"
                            variant="outline"
                            size="sm"
                            className="min-h-0 shrink-0"
                            onClick={() => {
                                exportSql();
                                toast.success("SQL export downloaded");
                            }}
                        >
                            <Download className="h-3.5 w-3.5" />
                            Export SQL
                        </Button>
                        <Button type="button" size="sm" className="min-h-0 shrink-0" asChild>
                            <Link to="/sales/leads/artifacts/new">
                                <Plus className="h-3.5 w-3.5" />
                                Add artefact
                            </Link>
                        </Button>
                    </div>
                }
            />

            <ArtifactsTable artifacts={artifacts} templates={templates} onRemove={removeArtifact} />
        </>
    );
}
